<div class="row row-cols-3 row-cols-md-4 ex-image text-dark no-gutters" >
    <div class="col mb-2 px-1" *ngFor="let pictureItem of pictures" >
        <app-picture-card (cardClick)="onCardClick(pictureItem)" [data]="pictureItem"></app-picture-card>
    </div>
</div>